<template>
  <div>

    <!-- Overlay modal -->
    <transition name="st-fade">
      <div v-if="open" class="st-overlay" @click.self="close">
        <div class="st-modal">

          <div class="st-modal__head">
            <button v-if="previewing" class="st-modal__back" @click="previewing = null">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            <span class="st-modal__title">{{ previewing ? previewing.name : 'Selecionar template' }}</span>
            <button class="st-modal__close" @click="close">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <!-- ── LISTA ── -->
          <template v-if="!previewing">

            <div class="st-bar">
              <div class="st-search-wrap">
                <svg class="st-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input class="st-search" type="text" placeholder="Pesquise pelo nome do template..." v-model="search" />
              </div>
              <button class="st-refresh" @click="getTemplates" :disabled="loading" title="Recarregar">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  :class="{ 'st-spin': loading }">
                  <polyline points="23 4 23 10 17 10" />
                  <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
                </svg>
              </button>
            </div>

            <div v-if="loading" class="st-loading">
              <span class="st-spinner"></span> Carregando templates...
            </div>

            <div v-if="!loading && loadError" class="st-alert">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              Nao foi possivel carregar. Verifique o servidor.
            </div>

            <div v-if="!loading && !loadError" class="st-list">
              <div v-for="tpl in filtered" :key="tpl.id || tpl.name" class="st-item"
                :class="{ 'st-item--active': selected && selected.name === tpl.name }" @click="previewTemplate(tpl)">
                <span class="st-item__name">{{ tpl.name }}</span>
                <svg v-if="selected && selected.name === tpl.name" width="15" height="15" viewBox="0 0 24 24"
                  fill="none" stroke="#00a884" stroke-width="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#adb5bd" stroke-width="2">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </div>
              <div v-if="!filtered.length" class="st-empty">
                <p>Nenhum template de campanha aprovado encontrado</p>
              </div>
            </div>

          </template>

          <!-- ── PREVIEW ── -->
          <template v-else>
            <div class="st-preview">

              <!-- Simulacao bolha WPP com botões integrados -->
              <div class="st-preview__wpp">
                <div class="st-preview__bubble">
                  <div v-if="previewHeader" class="st-preview__bubble-header">{{ previewHeader }}</div>
                  <div class="st-preview__bubble-body" v-html="previewBodyHtml"></div>
                  <div v-if="previewFooter" class="st-preview__bubble-footer">{{ previewFooter }}</div>
                  <div class="st-preview__bubble-meta">
                    <span>agora</span>
                    <svg width="14" height="10" viewBox="0 0 16 11" fill="none">
                      <path d="M1 5.5l3.5 3.5 5-8" stroke="#25d366" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M6 5.5l3.5 3.5 5-8" stroke="#25d366" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                  </div>
                </div>
                <!-- Botões dentro do contexto da bolha, igual WhatsApp real -->
                <div v-if="previewButtons.length" class="st-preview__bubble-buttons">
                  <button v-for="(btn, i) in previewButtons" :key="i" class="st-preview__bubble-btn">
                    <i v-if="btn.type === 'QUICK_REPLY'" class="fas fa-reply"></i>
                    <i v-else-if="btn.type === 'URL'" class="fas fa-external-link-alt"></i>
                    <i v-else-if="btn.type === 'PHONE_NUMBER'" class="fas fa-phone"></i>
                    {{ btn.text }}
                  </button>
                </div>
              </div>

            </div>

            <!-- Confirmar selecao -->
            <div class="st-preview__footer">
              <button class="st-btn-confirm" @click="confirmTemplate">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Usar este template
              </button>
            </div>
          </template>

        </div>
      </div>
    </transition>

    <!-- Variaveis — fora do modal, abaixo do preview no pai -->
    <div v-if="selected && variables.length" class="st-vars">
      <p class="st-vars__title">Variaveis do template</p>
      <div class="st-var" v-for="(v, i) in variables" :key="i">
        <span class="st-var__tag" v-text="varLabel(i)"></span>
        <input class="st-var__input" type="text" :placeholder="varPlaceholder(i)" v-model="variables[i].value"
          @input="emitPreview" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      allTemplates: [],
      dbTemplates: [],
      search: '',
      selected: null,
      previewing: null,
      variables: [],
      loading: false,
      loadError: false
    };
  },
  computed: {
    filtered() {
      var s = this.search.toLowerCase();
      if (!s) return this.allTemplates;
      return this.allTemplates.filter(function (t) {
        return t.name.toLowerCase().includes(s);
      });
    },
    previewHeader() {
      if (!this.previewing) return '';
      var comps = this.previewing.components || [];
      var h = comps.find(function (c) { return c.type === 'HEADER' && c.format === 'TEXT'; });
      return h ? h.text : '';
    },
    previewBodyHtml() {
      if (!this.previewing) return '';
      var comps = this.previewing.components || [];
      var b = comps.find(function (c) { return c.type === 'BODY'; });
      if (!b) return '';
      var text = b.text || '';
      text = text.replace(/\{\{\d+\}\}/g, function (m) {
        return '<span class="st-var-chip">' + m + '</span>';
      });
      text = text.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
      text = text.replace(/_(.*?)_/g, '<em>$1</em>');
      text = text.replace(/\n/g, '<br>');
      return text;
    },
    previewFooter() {
      if (!this.previewing) return '';
      var comps = this.previewing.components || [];
      var f = comps.find(function (c) { return c.type === 'FOOTER'; });
      return f ? f.text : '';
    },
    previewButtons() {
      if (!this.previewing) return [];
      var comps = this.previewing.components || [];
      var b = comps.find(function (c) { return c.type === 'BUTTONS'; });
      return b ? (b.buttons || []) : [];
    }
  },
  created() {
    this.getTemplates();
  },
  methods: {
    openModal() { this.open = true; this.previewing = null; },
    close() { this.open = false; this.previewing = null; },

    async getTemplates() {
      this.loading = true;
      this.loadError = false;
      try {
        // 1. Busca os dados locais (filas, template_type) do banco
        const dbRes = await axios.post('/getDbTemplates', { queues_ids: [] });
        this.dbTemplates = Array.isArray(dbRes.data) ? dbRes.data : [];

        // 2. Busca a lista da Meta
        const port = process.env.MIX_WEBHOOK_PORT;
        const res = await axios.get('https://api.advancemanagement.com.br:' + port + '/get_template_list');
        const data = res.data;
        const list = Array.isArray(data) ? data : (data.data || data.templates || []);

        // 3. Cruza com o banco e filtra: apenas APPROVED + template_type = CAMPANHA
        this.allTemplates = list
          .filter(t => t && t.name)
          .filter(t => t.status === 'APPROVED')
          .filter(t => {
            const dbFind = this.dbTemplates.find(d => d.template_id === t.id);
            return dbFind && dbFind.template_type === 'CAMPANHA';
          });

      } catch (e) {
        this.loadError = true;
      } finally {
        this.loading = false;
      }
    },

    previewTemplate(tpl) {
      this.previewing = tpl;
    },

    confirmTemplate() {
      var tpl = this.previewing;
      this.selected = tpl;
      this.variables = [];
      var body = this.getBodyText(tpl);
      var matches = body.match(/\{\{\d+\}\}/g) || [];
      var unique = matches.filter(function (v, i, a) { return a.indexOf(v) === i; });
      this.variables = unique.map(function (_, i) { return { index: i + 1, value: '' }; });
      this.$emit('template-selected', tpl);
      this.emitPreview();
      this.close();
    },

    getBodyText(tpl) {
      if (Array.isArray(tpl.components)) {
        var comp = tpl.components.find(function (c) { return c.type === 'BODY'; });
        if (comp) return comp.text || '';
      }
      return tpl.body || tpl.text || '';
    },

    emitPreview() {
      if (!this.selected) return;
      var text = this.getBodyText(this.selected);
      var vars = this.variables;
      vars.forEach(function (v, i) {
        var re = new RegExp('\\{\\{' + (i + 1) + '\\}\\}', 'g');
        text = text.replace(re, v.value || ('{{' + (i + 1) + '}}'));
      });
      this.$emit('preview-updated', {
        text: text,
        variables: this.variables,
        params: this.variables.map(function (v) { return { type: 'text', text: v.value }; })
      });
    },

    varLabel(i) { return '{{' + (i + 1) + '}}'; },
    varPlaceholder(i) { return 'Valor para {{' + (i + 1) + '}}'; }
  }
};
</script>

<style scoped>
/* ── Overlay ── */
.st-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.st-modal {
  background: #fff;
  border-radius: 14px;
  width: 440px;
  max-width: 95vw;
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, .18);
  overflow: hidden;
}

.st-modal__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid #e9edef;
  flex-shrink: 0;
}

.st-modal__title {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #111b21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.st-modal__back,
.st-modal__close {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: none;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667781;
  cursor: pointer;
  flex-shrink: 0;
  transition: background .15s;
}

.st-modal__back:hover,
.st-modal__close:hover {
  background: #e9edef;
}

.st-fade-enter-active,
.st-fade-leave-active {
  transition: opacity .2s;
}

.st-fade-enter,
.st-fade-leave-to {
  opacity: 0;
}

/* ── Search bar ── */
.st-bar {
  display: flex;
  gap: 8px;
  padding: 10px 14px;
  flex-shrink: 0;
}

.st-search-wrap {
  position: relative;
  flex: 1;
}

.st-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #667781;
  pointer-events: none;
}

.st-search {
  width: 100%;
  height: 36px;
  padding: 0 12px 0 32px;
  box-sizing: border-box;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  font-size: 13px;
  color: #111b21;
  outline: none;
  transition: border-color .15s;
}

.st-search:focus {
  border-color: #00a884;
}

.st-refresh {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667781;
  cursor: pointer;
  transition: border-color .15s, color .15s;
}

.st-refresh:hover:not(:disabled) {
  border-color: #00a884;
  color: #00a884;
}

.st-refresh:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.st-spin {
  animation: spin .7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.st-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #667781;
  padding: 12px 14px;
}

.st-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #e9edef;
  border-top-color: #00a884;
  border-radius: 50%;
  display: inline-block;
  animation: spin .7s linear infinite;
}

.st-alert {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  padding: 10px 14px;
  background: #fff1f0;
  color: #c62828;
}

/* ── Lista ── */
.st-list {
  flex: 1;
  overflow-y: auto;
}

.st-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f2f5;
  transition: background .1s;
}

.st-item:last-child {
  border-bottom: none;
}

.st-item:hover {
  background: #f0fdf4;
}

.st-item--active {
  background: #f0fdf4;
}

.st-item__name {
  font-size: 13px;
  font-weight: 500;
  color: #111b21;
  flex: 1;
}

.st-empty {
  padding: 24px;
  text-align: center;
}

.st-empty p {
  font-size: 13px;
  color: #adb5bd;
  margin: 0;
}

/* ── Preview ── */
.st-preview {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.st-preview__label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #adb5bd;
  margin-bottom: 6px;
}

.st-preview__wpp {
  background: #efeae2;
  border-radius: 10px;
  padding: 14px;
  background-image: url(/images/background-wpp.png);
  background-size: 80%;
  background-blend-mode: soft-light;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.st-preview__bubble {
  background: #fff;
  border-radius: 0 10px 10px 10px;
  padding: 10px 12px 7px;
  max-width: 90%;
  display: inline-block;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
  word-break: break-word;
}

.st-preview__bubble-header {
  font-size: 14px;
  font-weight: 700;
  color: #111b21;
  margin-bottom: 4px;
}

.st-preview__bubble-body {
  font-size: 13px;
  color: #111b21;
  line-height: 1.55;
}

.st-preview__bubble-footer {
  font-size: 12px;
  color: #667781;
  margin-top: 5px;
}

.st-preview__bubble-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;
  margin-top: 5px;
  font-size: 11px;
  color: #667781;
}

/* Botões dentro da bolha — igual ao WhatsApp real */
.st-preview__bubble-buttons {
  display: flex;
  flex-direction: column;
  gap: 1px;
  max-width: 90%;
  margin-top: 2px;
}

.st-preview__bubble-btn {
  width: 100%;
  background: #fff;
  border: none;
  border-top: 1px solid #e9edef;
  border-radius: 0;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #00a5f4;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.st-preview__bubble-btn:first-child {
  border-radius: 0 0 0 0;
}

.st-preview__bubble-btn:last-child {
  border-radius: 0 0 10px 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
}

.st-btn-icon {
  font-size: 12px;
}

.st-preview__footer {
  padding: 12px 16px;
  border-top: 1px solid #e9edef;
  flex-shrink: 0;
}

.st-btn-confirm {
  width: 100%;
  height: 40px;
  background: #25d366;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background .15s;
}

.st-btn-confirm:hover {
  background: #20bc5a;
}

/* ── Variaveis (fora do modal) ── */
.st-vars {
  padding: 10px 14px;
  background: #f8f9fa;
  border-top: 1px solid #e9edef;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.st-vars__title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #667781;
  margin: 0;
}

.st-var {
  display: flex;
  align-items: center;
  gap: 8px;
}

.st-var__tag {
  font-size: 12px;
  font-weight: 600;
  font-family: monospace;
  background: #e7f3ff;
  color: #0072ce;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.st-var__input {
  flex: 1;
  height: 34px;
  padding: 0 10px;
  border: 1.5px solid #e9edef;
  border-radius: 7px;
  font-size: 13px;
  color: #111b21;
  outline: none;
  transition: border-color .15s;
}

.st-var__input:focus {
  border-color: #00a884;
}

/* chip de variavel no preview */
.st-var-chip {
  display: inline-block;
  background: #fff3cd;
  color: #7c6000;
  border-radius: 4px;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 600;
}
</style>